import React, {Component} from 'react';
import SmartDialog from "../SmartDialog";
import {PaginatedView} from "../PaginatedView";
import TTLProxy from "../../common/TTLAsyncProxy";
import {AuditEndpoints, UsersEndpoints} from "../../common/ProxyEndpoints";
import {Badge, Button, Col, Row, UncontrolledAlert} from "reactstrap";
import Utils from "../../common/Utils";
import DatePicker from 'react-datepicker';
import ClearButton from "../CRUDView/Components/ClearButton";
import {Async as AsyncSelect, components} from "react-select";
import ThreeLineItemRender from "../Elements/ThreeLineItemRender";
import DialogCollapseSection from "../DialogCollapseSection";
import MDProgress from 'react-md-progress-bar';
import {css} from "glamor";
import moment from 'moment';
import AuditDetailsDialog from "./AuditDetailsDialog";
import {LevelBadge} from "./Elements";

const auditRecordBaseStyle = css({
    cursor: 'pointer',
    color: '#000000',
    '&:hover': {
        backgroundColor: '#d2d2d2'
    }
});

const validLimits = [
    20,
    50,
    100,
    500,
    10000
];

const logLevels = [
    {
        name: "All",
        value: "",
    },
    {
        name: "Info",
        value: "info"
    },
    {
        name: "Warning",
        value: "warn"
    },
    {
        name: "Verbose",
        value: "verbose"
    },
    {
        name: "Error",
        value: "error"
    }
];

class AuditExplorer extends Component {

    constructor(props){
        super(props);
        this.state = AuditExplorer.getInitialState();
        this.proxy= TTLProxy.getInstance();
    }

    static getInitialState(){

        return {
            records: [],
            users: null,
            limit: 100,
            search: "",
            message: "",
            action: "",
            user: null,
            level: "",
            source: "",
            start: null,
            end: null,
            error: null,
            isBusy: false
        };

    }

    async loadState(){

        this.setState({  isBusy: true , error: null });

        try {

            const {  user , start , end , level , search , message , action, source , limit } = this.state;

            const response = await this.proxy.processRequest(AuditEndpoints.getAll({
                offset: 0,
                limit,
                search: search ? search: undefined,
                message: message ? message : undefined,
                action: action ? action : undefined,
                source: source ? source : undefined,
                level: level ? level : undefined,
                user: user ? user.instance.id : undefined,
                from: start ? start.toJSON() : undefined,
                to: end ? end.toJSON() : undefined
            }));

            this.setState({
                records: response.getPayload()
            });

        }
        catch (e) {

            this.setState({
                error: e
            });

        }
        finally {

            this.setState({
                isBusy : false
            });

        }

    }

    show(){

        this.setState(AuditExplorer.getInitialState(), () => {
            this._dlg.show()
        });

    }

    render(){

        const {
            records,
            limit ,
            level ,
            source,
            message,
            action,
            start,
            end,
            search,
            error,
            user,
            isBusy
        } = this.state;

        return <SmartDialog ref={r => this._dlg = r} title="Audit Explorer" large>

            <AuditDetailsDialog ref={r => this._detailDlg = r}/>

            <div style={{ padding: 6 }}>

                <Row className="mb-1">

                    <Col md={3}>

                        <select name="level"
                                value={level}
                                className="form-control form-input-select"
                                onChange={evt => this.setState({
                            level: evt.target.value
                        })}>
                            {logLevels.map((l,k) => (<option key={k} value={l.value}>{l.name}</option>))}
                        </select>

                    </Col>

                    <Col md={9}>
                        <input type="text"
                               name="search"
                               className="form-control form-input-select"
                               placeholder="Search audit logs..." value={search} onChange={evt =>{

                            this.setState({
                                search: evt.target.value
                            });

                        }}/>
                    </Col>

                </Row>

                <hr/>

                <DialogCollapseSection title={<b>Extended Filters</b>} initiallyOpen={false}>

                    <Row className="mb-2">

                    <Col md={4}>

                        <b style={{ display: "block" }} className="mb-1">Message</b>
                        <input name="message"
                               type="text"
                               className="form-control form-input-select"
                               value={message} placeholder="Audit message" onChange={evt => this.setState({
                            message: evt.target.value
                        })}/>

                    </Col>

                    <Col md={4}>

                        <b style={{ display: "block" }} className="mb-1">Action</b>
                        <input name="action"
                               type="text"
                               value={action}
                               className="form-control form-input-select"
                               placeholder="Audit action" onChange={evt => this.setState({
                            action: evt.target.value
                        })}/>

                    </Col>

                    <Col md={4}>

                        <b style={{ display: "block" }} className="mb-1">Source</b>
                        <input name="source"
                               type="text"
                               className="form-control form-input-select"
                               value={source}
                               placeholder="Audit source" onChange={evt => this.setState({
                            source: evt.target.value
                        })}/>

                    </Col>

                </Row>

                    <Row className="mb-1">

                    <Col md={6}>

                        <div className="clearfix mb-1">
                            <b className="pull-left">User</b>
                            <div className="pull-right">
                                <ClearButton onClick={() => this.setState({
                                    user: null
                                })}/>
                            </div>
                        </div>

                        <AsyncSelect  name="user"
                                      cacheOptions
                                      placeholder="Search user accounts..."
                                      value={user}
                                      onChange={value => {

                                          this.setState({
                                              user: value
                                          });

                                      }}
                                      components={{
                                          Option: ({ children , ...props }) => {

                                              const user = props.data.instance;
                                              return <components.Option {...props}>

                                                  <ThreeLineItemRender media={user.media}
                                                                       line1Value={Utils.getUserName(user)}
                                                                       line2Prefix="Account Type"
                                                                       line2Value={user.role}
                                                                       line3Prefix="Phone"
                                                                       line3Value={user.phone}/>

                                              </components.Option>

                                          }
                                      }}
                                      loadOptions={async (value) => {

                                          try {

                                              const res = await this.proxy.processRequest(UsersEndpoints.getUrl(), {
                                                  search: { keyword: value , method: 'inside', fields: [
                                                          'username' ,
                                                          'email',
                                                          'phone' ,
                                                          'farmer.name',
                                                          'fbo.name',
                                                          'owner.name',
                                                          'admin.name',
                                                      ]},
                                                  pagination: { page: 1 , perPage : 5 },
                                                  include: [ 'media' , 'farmer' , 'fbo' , 'owner' , 'admin' ]
                                              });

                                              return res.getPayload().map(t => ({ label: Utils.getUserName(t), value: t.id  , instance: t }));
                                          }
                                          catch (e) {

                                              // failed to load query

                                          }

                                      }}/>
                    </Col>

                    <Col md={3}>

                        <b style={{ display: "block" }} className="mb-1"><i className="fa fa-calendar"/> From</b>
                        <DatePicker name="from"
                                    selected={start}
                                    className="form-control form-input-select"
                                    dropdownMode={"scroll"}
                                    onChange={() => { }} onSelect={date => this.setState({ start: date })}/>
                    </Col>

                    <Col md={3}>

                        <b style={{ display: "block" }} className="mb-1"><i className="fa fa-calendar"/> End</b>
                        <DatePicker name="to"
                                    selected={end}
                                    className="form-control form-input-select"
                                    dropdownMode={"scroll"}
                                    onChange={() => { }} onSelect={date => this.setState({ end: date })}/>

                    </Col>
                </Row>

                </DialogCollapseSection>

            </div>

            {isBusy && <MDProgress show/>}
            <hr/>

            <div className="clearfix">
                <div className="pull-right">
                    <Badge pill color="secondary">Total: <b>{records.length}</b></Badge>
                </div>
            </div>

            <PaginatedView data={records}
                           noRowsHeight={240}
                           height={380}
                           rowHeight={140}
                           emptyMessage="No records available."
                           renderItem={item => {

                               return <div className={`clearfix p-2 ${auditRecordBaseStyle}`} onClick={() => this._detailDlg.show(item)}>
                                   <div><b>Level</b>: <LevelBadge style={{ display: "inline" }} level={item.level}/></div>
                                   <div><b>Source</b>: {item.source}</div>
                                   <div><b>Action</b>: {item.action}</div>
                                   <div><b>Message</b>: {item.message}</div>
                                   <div><b>Timestamp</b>: {moment(item.timestamp).format('l hh:mm:ss')}</div>
                                   <div><b>User</b>: {item.user.username ? `${item.user.username} (${item.user.phone || item.user.email}) :: ${item.user.user_role}` : 'N/A'}</div>
                               </div>

                           }}/>

                           {error && <UncontrolledAlert color="danger"><i className="fa fa-exclamation-triangle"/> {Utils.getResponseError(error)}</UncontrolledAlert>}

                           <hr/>

                           <div className="clearfix">

                               <div className="pull-right">
                                   <Button style={{ minWidth: 120 }} color="green" onClick={() => this.loadState()}><i className="fa fa-search"/> Load Records</Button>
                               </div>

                               <div className="pull-left">
                                   <label>Limit:</label> <select value={limit} onChange={evt => {

                                       this.setState({
                                           limit: evt.target.value
                                       });

                               }}>
                                   {validLimits.map((c,k) => (<option key={k} value={c}>{c}</option>))}
                               </select>
                               </div>

                           </div>
        </SmartDialog>;

    }
}

export default AuditExplorer;


// WEBPACK FOOTER //
// ./src/components/AuditExplorer/AuditExplorer.js